import { useConfirmModal } from 'hooks/useConfirmModal'
import { ArticleVcmModalConfirm } from './ArticleVcmModalConfirm'
import { FolderVcmModalConfirm } from './FolderVcmModalConfirm'
import { FileType } from 'types'

export const useVcmConfirm = (fileType: FileType) =>
  useConfirmModal(fileType === 'article' ? ArticleVcmModalConfirm : FolderVcmModalConfirm)
